import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import WidgetLoading from "../../shared/loaders/WidgetLoading";
import {
  RatingStepWrapper,
  Title,
  Field,
  TextInput,
  Note,
  SubmitButton,
  FakeSubmitButton,
  StepCount,
} from "../styles/form-steps-styles";

const MessageStep = ({
  step,
  recruiterName,
  agencyName,
  reviewMessage,
  setReviewMessage,
  formLoading,
}) => (
  <RatingStepWrapper noPointerEvents={step}>
    {formLoading ? (
      <WidgetLoading />
    ) : (
      <Fragment>
        <Title data-test-id="step5-rating-title">
          Please leave a review for <strong>{recruiterName}</strong> at{" "}
          <strong>{agencyName}</strong>
        </Title>
        <Field className="animated fadeInDown delay">
          <TextInput
            placeholder="It really helps if you can leave a short note to review their performance..."
            value={reviewMessage}
            spellCheck="false"
            onChange={setReviewMessage}
            minLength={30}
            data-test-id="message-input"
          />
        </Field>
        {reviewMessage.length < 30 && (
          <Note
            className="animated fadeInDown delay-1"
            data-test-id="min-char-note"
          >
            <FontAwesomeIcon icon={faInfoCircle} />
            Minimum of 30 characters required
          </Note>
        )}
        {reviewMessage.length < 30 ? (
          <FakeSubmitButton
            type="button"
            className="animated fadeInUp delay-1"
            data-test-id="fake-submit-button"
          >
            Submit
          </FakeSubmitButton>
        ) : (
          <SubmitButton type="submit" data-test-id="submit-button">
            Submit
          </SubmitButton>
        )}
        <StepCount data-test-id="step-count">step 5 of 5</StepCount>
      </Fragment>
    )}
  </RatingStepWrapper>
);

MessageStep.propTypes = {
  step: PropTypes.number.isRequired,
  recruiterName: PropTypes.string.isRequired,
  agencyName: PropTypes.string.isRequired,
  reviewMessage: PropTypes.string.isRequired,
  setReviewMessage: PropTypes.func.isRequired,
  formLoading: PropTypes.bool.isRequired,
};

export default MessageStep;
